import { type ComponentProps, useEffect, useState } from 'react'
import { View } from 'tamagui'

/**
 * Pulsing skeleton placeholder. The pulse loops opacity through Tamagui's
 * animation driver (toggled on an interval) rather than a hand-written
 * `@keyframes`, so it stays inside the theme/animation system.
 *
 * Pass `width`/`height`/`borderRadius` to shape it. `backgroundColor` defaults
 * to a subtle raised surface and can be overridden; `animation`/`opacity` are
 * driven internally and shouldn't be set by callers.
 */
export default function Skeleton(props: ComponentProps<typeof View>) {
    const [dim, setDim] = useState(false)
    useEffect(() => {
        const id = setInterval(() => setDim(d => !d), 700)
        return () => clearInterval(id)
    }, [])
    return (
        <View
            backgroundColor="$backgroundRaised"
            {...props}
            animation="lazy"
            opacity={dim ? 0.4 : 1}
        />
    )
}
